


class SocialFloating extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };

    this.querySelectorAll('[data-social-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!theme.config.mqlSmall) return;
    this.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    this.classList.add(this.classes.activeClass);

    // close promo-popup
    const popup = document.querySelector('promo-popup');
    popup && popup.close();
  }

  close() {
    this.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.classList.remove(this.classes.activeClass);
      this.classList.remove(this.classes.closingClass);
    }, 500);
  }
}
customElements.define('social-floating', SocialFloating);

class PromoPopup extends HTMLElement {
  constructor() {
    super();
    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'beyours:promo-popup';
    this.classes = {
      bodyClass: 'promo-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image'
    };

    this.popup = this.querySelector('.promo-popup');
    this.floating = this.querySelector('.popup-floating');
    this.floatingStorageKey = 'padasnap:promo-floating-dismissed';
    this.floatingDismissed = false;
    try {
      this.floatingDismissed = sessionStorage.getItem(this.floatingStorageKey) === 'true';
    } catch {}
    if (this.floating) this.floating.hidden = this.floatingDismissed;
    this.querySelector('[data-popup-dismiss]')?.addEventListener('click', () => this.dismissFloating());
    this.imagePromises = new WeakMap();
    this.openRequest = 0;
    this.opening = false;

    // Open modal if errors or success message exist
    if (this.querySelector('.form__message')) {
      this.open()


      // 当用户订阅成功显示促销文案
      // 手机端
      let mobile_popup_text_list = document.getElementsByClassName('mobile_cus_popup_text')
      for (let i = 0; i < mobile_popup_text_list.length; i++) {
        mobile_popup_text_list[i].style.display = 'none';
      }

      // PC 端
      let pc_popup_text_list = document.getElementsByClassName('pc_cus_popup_text')
      for (let i = 0; i < pc_popup_text_list.length; i++) {
        pc_popup_text_list[i].style.display = 'none';
      }


      let popup_general_text = document.getElementById('popup_general_text')
      popup_general_text.style.display = 'unset'

      let popup_general_text_rte = document.getElementById('popup_general_text_rte')
      popup_general_text_rte.style.fontSize = '2.2rem'

      let popup__subheading_moblie_list = document.getElementsByClassName('popup__subheading_moblie')
      for (let i = 0; i < popup__subheading_moblie_list.length; i++) {
        popup__subheading_moblie_list[i].style.fontSize = '1.6rem'
        popup__subheading_moblie_list[i].style.color = 'rgba(var(--color-foreground), 0.55)'
      }

    }

    this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    if (!this.floatingDismissed && (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true')) {
      this.init();
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    this.openRequest += 1;
    clearTimeout(this.openTimer);
    clearTimeout(this.imageRevealTimer);
    clearTimeout(this.closeTimer);
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);

      document.body.classList.remove(this.classes.bodyClass);
    }
  }
  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  init() {
    if(!this.popup) {
      return;
    }

    if (Shopify && Shopify.designMode) {
      return;
    }

    // Prepare only this device's artwork after the visible main image is ready.
    this.waitForMainImage().then(() => {
      const prepare = () => {
        if (this.isConnected && !this.floatingDismissed) this.prepareImage(this.getPopupImage());
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prepare, { timeout: 1000 });
      } else {
        setTimeout(prepare, 0);
      }
    });
    this.openTimer = setTimeout(() => this.open(), parseInt(this.dataset.delay) * 1000);
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.popup) return;
    this.popup.classList.contains(this.classes.activeClass) || this.opening ? this.close() : this.open();
  }

  dismissFloating() {
    this.floatingDismissed = true;
    if (this.floating) this.floating.hidden = true;
    clearTimeout(this.openTimer);
    this.openRequest += 1;
    this.opening = false;
    try {
      sessionStorage.setItem(this.floatingStorageKey, 'true');
    } catch {}
  }

  getPopupImage() {
    const selector = window.matchMedia('(max-width: 749px)').matches
      ? '.moblie_popup_image img' : '.popup__image img';
    return this.popup && this.popup.querySelector(selector);
  }

  waitForMainImage() {
    if (!this.mainImageReady) {
      this.mainImageReady = new Promise((resolve) => {
        const wait = () => {
          const images = Array.from(document.querySelectorAll('#MainContent img'));
          const image = images.filter((img) => {
            const rect = img.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0 && rect.bottom > 0 &&
              rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
          }).sort((a, b) => {
            const ar = a.getBoundingClientRect();
            const br = b.getBoundingClientRect();
            return br.width * br.height - ar.width * ar.height;
          })[0];
          if (!image || image.complete) return resolve();
          const done = () => {
            clearTimeout(timer);
            image.removeEventListener('load', done);
            image.removeEventListener('error', done);
            resolve();
          };
          const timer = setTimeout(done, 5000);
          image.addEventListener('load', done, { once: true });
          image.addEventListener('error', done, { once: true });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', wait, { once: true });
        } else {
          wait();
        }
      });
    }
    return this.mainImageReady;
  }

  prepareImage(image) {
    if (!image) return Promise.resolve(false);
    if (this.imagePromises.has(image)) return this.imagePromises.get(image);
    const ready = new Promise((resolve) => {
      let settled = false;
      const finish = (loaded) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        image.removeEventListener('load', loadedImage);
        image.removeEventListener('error', failedImage);
        resolve(loaded);
      };
      const loadedImage = () => {
        if (!image.naturalWidth) return finish(false);
        if (image.decode) {
          image.decode().then(() => finish(true), () => finish(image.naturalWidth > 0));
        } else {
          finish(true);
        }
      };
      const failedImage = () => finish(false);
      const timer = setTimeout(failedImage, 5000);
      image.addEventListener('load', loadedImage, { once: true });
      image.addEventListener('error', failedImage, { once: true });
      image.fetchPriority = 'low';
      image.loading = 'eager';
      if (image.complete) loadedImage();
    });
    this.imagePromises.set(image, ready);
    ready.then((loaded) => {
      if (!loaded) this.imagePromises.delete(image);
    });
    return ready;
  }


  hideShopifyChat() {
    console.log('hideShopifyChat')
    let shopifyChatElement = document.getElementById('shopify-chat');
    if (shopifyChatElement) {
        shopifyChatElement.style.display = 'none';
    }
  }

  showShopifyChat(){
    console.log('showShopifyChat')
    let shopifyChatElement = document.getElementById('shopify-chat');
    if (shopifyChatElement) {
        shopifyChatElement.style.display = 'unset';
    }
  }

  async open() {
    if (!this.popup) return;
    const request = ++this.openRequest;
    this.opening = true;
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    await this.waitForMainImage();
    if (request !== this.openRequest || !this.isConnected) return;
    let image = this.getPopupImage();
    let loaded = await this.prepareImage(image);
    // A device rotation while waiting can select different artwork.
    if (image !== this.getPopupImage()) {
      image = this.getPopupImage();
      loaded = await this.prepareImage(image);
    }
    if (request !== this.openRequest || !this.isConnected) return;
    this.opening = false;
    this.popup.classList.toggle('popup--image-unavailable', !loaded);
    document.body.classList.remove(this.classes.bodyClass);
    this.popup.classList.remove(this.classes.closingClass);
    this.popup.classList.add(this.classes.activeClass);
    this.hideShopifyChat();
    clearTimeout(this.imageRevealTimer);
    this.imageRevealTimer = setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
    }, 600);

    if (this.popup.dataset.position === 'center') {
      setScrollbarWidth();
      document.body.classList.add(this.classes.bodyClass);
    }

    // close social-floating
    const social = document.querySelector('social-floating');
    social && social.close();
  }

  close() {
    if (!this.popup) return;
    this.openRequest += 1;
    this.opening = false;
    clearTimeout(this.openTimer);
    clearTimeout(this.imageRevealTimer);
    this.popup.classList.add(this.classes.closingClass);

    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);

      if (this.popup.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
      }
      this.showShopifyChat()
    }, 500);

    // Remove a cookie in case it was set in test mode
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.dataset.expiry);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('promo-popup', PromoPopup);

